const $ = jQuery.noConflict();
const showColumns = 12;
class LoadTaxonomies {
	constructor() {
		this.loadMore = $('.load-more');
		this.card___columns = $('.poeple-card__column');
	}
	bindEvents() {
		this.loadMore.on('click', this.showMore);
	}
	showMore(e) {
		e.preventDefault();
		const $hiddenItems = $('.column-hide');
		if ($hiddenItems.length > 0) {
			$hiddenItems.slice(0, showColumns).removeClass('column-hide');
		} else {
			$(this).prop('disabled', true).text('No More Items');
		}

	}
	countElements() {
		this.numColumns = $('.poeple-card__column').length;
		if (this.numColumns > showColumns) {
			this.card___columns.slice(showColumns).addClass('column-hide');
			$('.load-more').show();
		}
		else{
			$('.load-more').hide();
		}
	}
	init() {
		this.bindEvents();
		this.countElements();
	}

}
export default new LoadTaxonomies();
